export default "__VITE_ASSET__VyWhFQe2__"